<script setup>
import { computed } from "vue";
import Skeleton from "./Skeleton.vue";
import { useI18n } from "vue-i18n";

const props = defineProps({
    form: {
        type: Object,
        required: true,
    },
    focusedElement: {
        type: String,
        required: false,
    },
});

const { t: __ } = useI18n();

const hasThumbnailImage = computed(() => props.form.settings.images.thumbnail.enabled);
const hasContentImages = computed(() => props.form.settings.images.content.enabled);
const hasYoutube = computed(() => props.form.settings.youtube.enabled);
const hasEmbeds = computed(() => props.form.settings.embeds.enabled);
</script>
<template>
    <div class="space-y-6">
        <Skeleton v-if="hasThumbnailImage" class="h-32" :animated="focusedElement === 'images'">
            <div class="text-sm font-bold text-gray-300">
                {{ __("Image mise en avant") }}
            </div>
        </Skeleton>
        <div class="space-y-1">
            <Skeleton class="w-10/12" :animated="focusedElement === 'summary'" />
            <Skeleton class="w-11/12" :animated="focusedElement === 'summary'" />
            <Skeleton class="w-7/12" :animated="focusedElement === 'summary'" />
        </div>

        <Skeleton v-if="hasYoutube" class="h-32" :animated="focusedElement === 'youtube'">
            <div class="text-sm font-bold text-gray-300">
                {{ __("Vidéo YouTube") }}
            </div>
        </Skeleton>

        <Skeleton class="w-6/12 h-8" :animated="focusedElement === 'content'" />

        <Skeleton v-if="hasContentImages" class="h-32" :animated="focusedElement === 'images'">
            <div class="text-sm font-bold text-gray-300">
                {{ __("Image de contenu") }}
            </div>
        </Skeleton>

        <div class="space-y-1">
            <Skeleton class="w-11/12" :animated="focusedElement === 'content'" />
            <Skeleton class="w-8/12" :animated="focusedElement === 'content'" />
            <Skeleton class="w-6/12" :animated="focusedElement === 'content'" />
        </div>

        <Skeleton v-if="hasContentImages" class="h-32" :animated="focusedElement === 'images'">
            <div class="text-sm font-bold text-gray-300">
                {{ __("Image de contenu") }}
            </div>
        </Skeleton>

        <Skeleton class="w-6/12 h-8" :animated="focusedElement === 'content'" />

        <div class="space-y-1">
            <Skeleton class="w-11/12" :animated="focusedElement === 'content'" />
            <Skeleton class="w-8/12" :animated="focusedElement === 'content'" />
            <Skeleton class="w-6/12" :animated="focusedElement === 'content'" />
        </div>

        <Skeleton v-if="hasEmbeds" class="h-32" :animated="focusedElement === 'embed'">
            <div class="text-sm font-bold text-gray-300">
                {{ __("Embed de réseau social") }}
            </div>
        </Skeleton>
    </div>
</template>
